(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-banner-carousel"] && !Shopify.designMode) return;
  try {
    
  class NbCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.nb-carousel__track');
      this.slides = Array.from(this.querySelectorAll('.nb-carousel__slide'));
      this.dots = Array.from(this.querySelectorAll('.nb-carousel__dot'));
      this.index = 0;
      if (this.slides.length < 2) return;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.querySelectorAll('.nb-carousel__arrow').forEach((button) =>
        button.addEventListener('click', () => this.show(this.index + Number(button.dataset.dir)))
      );
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.index))));

      // The track scrolls natively (swipe, trackpad); follow whichever slide is centered.
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.setActive(this.slides.indexOf(entry.target));
          });
        },
        { root: this.track, rootMargin: '0px -45% 0px -45%', threshold: 0 }
      );
      this.slides.forEach((slide) => this.observer.observe(slide));

      // Keep a banner on both sides of the active one, so the row never ends in a blank.
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.rebalance(), 150);
      });
      this.rebalance();

      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.play());

      // Theme editor: show the slide being edited and stop rotating.
      this.addEventListener('shopify:block:select', (event) => {
        this.inEditor = true;
        this.pause();
        this.show(this.slides.indexOf(event.target));
      });
      this.addEventListener('shopify:block:deselect', () => {
        this.inEditor = false;
        this.play();
      });

      this.play();
    }

    disconnectedCallback() {
      this.pause();
      if (this.observer) this.observer.disconnect();
    }

    show(index) {
      const count = this.slides.length;
      const target = ((index % count) + count) % count;
      const slide = this.slides[target];
      this.rebalance(slide);
      this.setActive(target);
      this.track.scrollTo({
        left: this.centerOf(slide),
        behavior: this.reducedMotion ? 'auto' : 'smooth',
      });
    }

    // Moves a slide from the far end next to the given one without a visible jump.
    rebalance(slide = this.slides[this.index]) {
      if (this.slides.length < 3) return;
      if (!slide.previousElementSibling) this.track.prepend(this.track.lastElementChild);
      else if (!slide.nextElementSibling) this.track.append(this.track.firstElementChild);
      else return;
      this.track.scrollTo({ left: this.centerOf(this.slides[this.index]), behavior: 'instant' });
    }

    centerOf(slide) {
      return slide.offsetLeft - (this.track.clientWidth - slide.clientWidth) / 2;
    }

    setActive(index) {
      this.index = index;
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      this.dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    play() {
      if (this.dataset.autoplay !== 'true' || this.reducedMotion || this.inEditor || this.timer) return;
      this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.speed) * 1000);
    }

    pause() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('nb-carousel')) customElements.define('nb-carousel', NbCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-contact"] && !Shopify.designMode) return;
  try {
    
  class NbContact extends HTMLElement {
    connectedCallback() {
      this.type = this.querySelector('[data-contact-type]');
      this.fields = Array.from(this.querySelectorAll('[data-show-for]'));
      if (!this.type) return;
      this.type.addEventListener('change', () => this.update());
      this.update();
    }

    // Show only the fields that matter for the selected kind of enquiry.
    update() {
      const option = this.type.selectedOptions[0];
      const group = option && option.dataset.group;
      this.fields.forEach((field) => {
        const show = !group || field.dataset.showFor.split(' ').includes(group);
        field.hidden = !show;
        const input = field.querySelector('input');
        if (input && input.id === 'Contact-company') input.required = group === 'business';
      });
    }
  }

  if (!customElements.get('nb-contact')) customElements.define('nb-contact', NbContact);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-product-tabs"]) return;
  try {
    
  class NbProductTabs extends HTMLElement {
    // Reviews: filter by rating group and reveal one page at a time.
    initReviews() {
      const items = Array.from(this.querySelectorAll('.nb-reviews__item'));
      if (!items.length) return;
      const more = this.querySelector('[data-reviews-more]');
      const filters = Array.from(this.querySelectorAll('[data-reviews-filter]'));
      const pageSize = more ? Number(more.dataset.pageSize) : items.length;
      let filter = 'all';
      let visible = pageSize;

      const update = () => {
        const matching = items.filter((item) => filter === 'all' || item.dataset.ratingGroup === filter);
        items.forEach((item) => (item.hidden = true));
        matching.slice(0, visible).forEach((item) => (item.hidden = false));
        if (more) more.parentElement.hidden = matching.length <= visible;
      };

      if (more) {
        more.addEventListener('click', () => {
          visible += pageSize;
          update();
        });
      }

      filters.forEach((button) => {
        button.addEventListener('click', () => {
          filter = button.dataset.reviewsFilter;
          visible = pageSize;
          filters.forEach((other) => other.setAttribute('aria-pressed', other === button));
          update();
        });
      });
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(tab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          const step = event.key === 'ArrowRight' ? 1 : -1;
          const next = this.tabs[(index + step + this.tabs.length) % this.tabs.length];
          this.select(next);
          next.focus();
        });
      });

      this.initReviews();

      // Buttons elsewhere on the page (next to the buy buttons) link to "#ProductTab-…".
      this.onJump = (event) => {
        const link = event.target.closest('a[href^="#ProductTab-"]');
        if (!link) return;
        const tab = this.querySelector(link.getAttribute('href'));
        if (!tab) return;
        event.preventDefault();
        this.select(tab);
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scrollIntoView({ block: 'start', behavior: smooth ? 'smooth' : 'auto' });
      };
      document.addEventListener('click', this.onJump);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onJump);
    }

    select(target) {
      this.tabs.forEach((tab) => {
        const selected = tab === target;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        document.getElementById(tab.getAttribute('aria-controls')).hidden = !selected;
      });
    }
  }

  if (!customElements.get('nb-product-tabs')) customElements.define('nb-product-tabs', NbProductTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-ranking"] && !Shopify.designMode) return;
  try {
    
  class NbTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      if (this.tabs.length < 2) return;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          const step = event.key === 'ArrowRight' ? 1 : -1;
          const next = (index + step + this.tabs.length) % this.tabs.length;
          this.select(next);
          this.tabs[next].focus();
        });
        // Theme editor: open the tab being edited.
        tab.addEventListener('shopify:block:select', () => this.select(index));
      });
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        document.getElementById(tab.getAttribute('aria-controls')).hidden = !selected;
      });
    }
  }

  if (!customElements.get('nb-tabs')) customElements.define('nb-tabs', NbTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-scene-finder"] && !Shopify.designMode) return;
  try {
    
  class NbScenes extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('button.nb-scenes__tab'));
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          this.open(button);
          // The list of scenes is long; bring the opened panel back into view.
          const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.panelFor(button).scrollIntoView({ block: 'nearest', behavior: smooth ? 'smooth' : 'auto' });
        });
        // Theme editor: open the scene being edited.
        button.addEventListener('shopify:block:select', () => this.open(button));
      });
    }

    panelFor(button) {
      return document.getElementById(button.getAttribute('aria-controls'));
    }

    open(target) {
      this.buttons.forEach((button) => {
        const expanded = button === target;
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        this.panelFor(button).hidden = !expanded;
      });
    }
  }

  if (!customElements.get('nb-scenes')) customElements.define('nb-scenes', NbScenes);

  } catch(e) { console.error(e); }
})();
})();
